import { Module, MutationTree, ActionContext, ActionTree, GetterTree } from "vuex";

import { RootState } from "../root/types";
import { UserLoginInfo, VuexDictionary, UserToken, UserProfile } from "@tt-app/models";
import { VUEX_USER_MUTATION_NAMES } from "@tt-app/constants/user";
import { VuexUserMutationNameList } from "@tt-app/constants/user";

export interface UserModule extends Module<UserState, RootState> {
  namespaced: true;
  state: UserState;
  actions: UserActions;
  mutations: UserMutations;
  getters: UserGetters;
}

export const VUEX_USER_ACTIONS_NAME: VuexDictionary = {
  LOGIN: "login"
};
export const VUEX_USER_MUTATIONS_NAME: VuexDictionary = {
  LOGIN: "updateUserToken"
};

export interface Alias {
  id: number;
  uuid: string;
  name: string;
}

export enum NotificationPermission {
  DEFAULT = "default",
  GRANTED = "granted",
  DENIED = "denied"
}

// groupNames, orgName, and userName are returned from the temporary password validation endpoint
// and are only used for the PwdChangeFromInvitation.vue component for the moment
export interface UserState {
  aliases: Alias[];
  authentication: {
    error?: string;
    jwtValidationError: string;
    tmpPasswordValidated: boolean;
    token?: string;
  };
  course: {
    history: {};
  };
  groupNames: string[];
  // groups is set undefined at first to adhere to the following ideals regarding state:
  // - undefined value  = loading
  // - empty value      = loaded successfully with empty data
  // - non-empty value  = loaded successfully with non-empty data
  groups?: any[];
  orgName: string;
  userName: string;
  // Profile loaded for user settings. UserProfile also has an orgName field but no aliases
  // fields

  profile?: UserProfile;
  // Password reset dedicated error and status field
  pwdReset: {
    error: string;
  };
  selectedAlias?: Alias;
}

export type UserMutations = {
  //   updateUser: (state: UserState, user: User) => void;
  //   updateProfile: (state: UserState, profile: Profile) => void;
  //   addSNS: (state: UserState, name: string) => void;
  //   removeSNS: (state: UserState, name: string) => void;
  //   updateIab: (state: UserState, message: string) => void;
  //   updateCheckTempPassword: (state: UserState, status: boolean) => void;
};

export type UserActionContext = ActionContext<UserState, RootState>;

export type UserActions = ActionTree<UserState, RootState>;

export type UserGetters = GetterTree<UserState, RootState>;
